/**
 * Lobe Icons 静态导入
 * 将所有需要的图标预先导入，避免动态导入问题
 */
import {
  Adobe,
  AdobeFirefly,
  Agui,
  Ai2,
  Ai21,
  Ai302,
  Ai360,
  AiHubMix,
  AiMass,
  AionLabs,
  AiStudio,
  AkashChat,
  AlephAlpha,
  Alibaba,
  AlibabaCloud,
  Anthropic,
  Anyscale,
  Apple,
  Arcee,
  AssemblyAI,
  Automatic,
  Aws,
  Aya,
  Azure,
  AzureAI,
  BAAI,
  Baichuan,
  Baidu,
  BaiduCloud,
  Bailian,
  Baseten,
  Bedrock,
  Bfl,
  Bilibili,
  BilibiliIndex,
  Bing,
  BurnCloud,
  ByteDance,
  CapCut,
  CentML,
  Cerebras,
  ChatGLM,
  Civitai,
  Claude,
  Cline,
  Clipdrop,
  Cloudflare,
  CodeFlicker,
  CodeGeeX,
  CogVideo,
  CogView,
  Cohere,
  Colab,
  CometAPI,
  ComfyUI,
  CommandA,
  Copilot,
  CopilotKit,
  Coqui,
  Coze,
  CrewAI,
  Crusoe,
  Cursor,
  CyberCut,
  Dalle,
  Dbrx,
  DeepAI,
  DeepCogito,
  DeepInfra,
  DeepL,
  DeepMind,
  DeepSeek,
  Dify,
  Doc2X,
  DocSearch,
  Dolphin,
  Doubao,
  DreamMachine,
  ElevenLabs,
  ElevenX,
  EssentialAI,
  Exa,
  Fal,
  FastGPT,
  Featherless,
  Figma,
  Fireworks,
  FishAudio,
  Flora,
  Flowith,
  Flux,
  Friendli,
  GLMV,
  Gemini,
  Gemma,
  GiteeAI,
  Github,
  GithubCopilot,
  Glama,
  Glif,
  Google,
  GoogleCloud,
  Goose,
  Gradio,
  Greptile,
  Grok,
  Groq,
  Hailuo,
  Haiper,
  Hedra,
  Higress,
  Huawei,
  HuaweiCloud,
  HuggingFace,
  Hunyuan,
  Hyperbolic,
  IBM,
  IFlyTekCloud,
  Ideogram,
  Inception,
  Inference,
  Infermatic,
  Infinigence,
  Inflection,
  InternLM,
  Jimeng,
  Jina,
  Kimi,
  Kling,
  Kluster,
  Kolors,
  Krea,
  KwaiKAT,
  Kwaipilot,
  LG,
  LLaVA,
  Lambda,
  LangChain,
  LangGraph,
  LangSmith,
  Langfuse,
  LeptonAI,
  Lightricks,
  Liquid,
  LiveKit,
  LlamaIndex,
  LmStudio,
  LobeHub,
  LongCat,
  Lovable,
  Luma,
  MCP,
  Magic,
  Make,
  Manus,
  Mastra,
  McpSo,
  Menlo,
  Meta,
  MetaAI,
  MetaGPT,
  Microsoft,
  Midjourney,
  Minimax,
  Mistral,
  ModelScope,
  Monica,
  Moonshot,
  Morph,
  MyShell,
  N8n,
  NPLCloud,
  Nebius,
  NewAPI,
  NotebookLM,
  Notion,
  NousResearch,
  Nova,
  NovelAI,
  Novita,
  Nvidia,
  Ollama,
  OpenAI,
  OpenChat,
  OpenRouter,
  OpenWebUI,
  PPIO,
  PaLM,
  Parasail,
  Perplexity,
  Phidata,
  Phind,
  Pika,
  PixVerse,
  Player2,
  Poe,
  Pollinations,
  PydanticAI,
  Qingyan,
  Qiniu,
  Qwen,
  RSSHub,
  Railway,
  Recraft,
  Relace,
  Replicate,
  Replit,
  Runway,
  Rwkv,
  SambaNova,
  Search1API,
  SearchApi,
  SenseNova,
  SiliconCloud,
  Skywork,
  Smithery,
  Snowflake,
  SophNet,
  Sora,
  Spark,
  Stability,
  StateCloud,
  Stepfun,
  Straico,
  StreamLake,
  SubModel,
  Suno,
  Sync,
  TII,
  Targon,
  Tavily,
  Tencent,
  TencentCloud,
  Tiangong,
  Together,
  TopazLabs,
  Trae,
  Tripo,
  TuriX,
  Udio,
  Unstructured,
  Upstage,
  V0,
  VectorizerAI,
  Vercel,
  VertexAI,
  Vidu,
  Viggle,
  Vllm,
  Volcengine,
  Voyage,
  Wenxin,
  Windsurf,
  WorkersAI,
  XAI,
  XiaomiMiMo,
  Xinference,
  Xuanyuan,
  Yandex,
  Yi,
  YouMind,
  Yuanbao,
  ZAI,
  Zapier,
  Zeabur,
  ZenMux,
  ZeroOne,
  Zhipu,
} from '@lobehub/icons';

// 图标映射表
export const LOBE_ICONS: Record<string, React.ComponentType<{ size?: number }>> = {
  Adobe,
  AdobeFirefly,
  Agui,
  Ai2,
  Ai21,
  Ai302,
  Ai360,
  AiHubMix,
  AiMass,
  AionLabs,
  AiStudio,
  AkashChat,
  AlephAlpha,
  Alibaba,
  AlibabaCloud,
  Anthropic,
  Anyscale,
  Apple,
  Arcee,
  AssemblyAI,
  Automatic,
  Aws,
  Aya,
  Azure,
  AzureAI,
  BAAI,
  Baichuan,
  Baidu,
  BaiduCloud,
  Bailian,
  Baseten,
  Bedrock,
  Bfl,
  Bilibili,
  BilibiliIndex,
  Bing,
  BurnCloud,
  ByteDance,
  CapCut,
  CentML,
  Cerebras,
  ChatGLM,
  Civitai,
  Claude,
  Cline,
  Clipdrop,
  Cloudflare,
  CodeFlicker,
  CodeGeeX,
  CogVideo,
  CogView,
  Cohere,
  Colab,
  CometAPI,
  ComfyUI,
  CommandA,
  Copilot,
  CopilotKit,
  Coqui,
  Coze,
  CrewAI,
  Crusoe,
  Cursor,
  CyberCut,
  Dalle,
  Dbrx,
  DeepAI,
  DeepCogito,
  DeepInfra,
  DeepL,
  DeepMind,
  DeepSeek,
  Dify,
  Doc2X,
  DocSearch,
  Dolphin,
  Doubao,
  DreamMachine,
  ElevenLabs,
  ElevenX,
  EssentialAI,
  Exa,
  Fal,
  FastGPT,
  Featherless,
  Figma,
  Fireworks,
  FishAudio,
  Flora,
  Flowith,
  Flux,
  Friendli,
  GLMV,
  Gemini,
  Gemma,
  GiteeAI,
  Github,
  GithubCopilot,
  Glama,
  Glif,
  Google,
  GoogleCloud,
  Goose,
  Gradio,
  Greptile,
  Grok,
  Groq,
  Hailuo,
  Haiper,
  Hedra,
  Higress,
  Huawei,
  HuaweiCloud,
  HuggingFace,
  Hunyuan,
  Hyperbolic,
  IBM,
  IFlyTekCloud,
  Ideogram,
  Inception,
  Inference,
  Infermatic,
  Infinigence,
  Inflection,
  InternLM,
  Jimeng,
  Jina,
  Kimi,
  Kling,
  Kluster,
  Kolors,
  Krea,
  KwaiKAT,
  Kwaipilot,
  LG,
  LLaVA,
  Lambda,
  LangChain,
  LangGraph,
  LangSmith,
  Langfuse,
  LeptonAI,
  Lightricks,
  Liquid,
  LiveKit,
  LlamaIndex,
  LmStudio,
  LobeHub,
  LongCat,
  Lovable,
  Luma,
  MCP,
  Magic,
  Make,
  Manus,
  Mastra,
  McpSo,
  Menlo,
  Meta,
  MetaAI,
  MetaGPT,
  Microsoft,
  Midjourney,
  Minimax,
  Mistral,
  ModelScope,
  Monica,
  Moonshot,
  Morph,
  MyShell,
  N8n,
  NPLCloud,
  Nebius,
  NewAPI,
  NotebookLM,
  Notion,
  NousResearch,
  Nova,
  NovelAI,
  Novita,
  Nvidia,
  Ollama,
  OpenAI,
  OpenChat,
  OpenRouter,
  OpenWebUI,
  PPIO,
  PaLM,
  Parasail,
  Perplexity,
  Phidata,
  Phind,
  Pika,
  PixVerse,
  Player2,
  Poe,
  Pollinations,
  PydanticAI,
  Qingyan,
  Qiniu,
  Qwen,
  RSSHub,
  Railway,
  Recraft,
  Relace,
  Replicate,
  Replit,
  Runway,
  Rwkv,
  SambaNova,
  Search1API,
  SearchApi,
  SenseNova,
  SiliconCloud,
  Skywork,
  Smithery,
  Snowflake,
  SophNet,
  Sora,
  Spark,
  Stability,
  StateCloud,
  Stepfun,
  Straico,
  StreamLake,
  SubModel,
  Suno,
  Sync,
  TII,
  Targon,
  Tavily,
  Tencent,
  TencentCloud,
  Tiangong,
  Together,
  TopazLabs,
  Trae,
  Tripo,
  TuriX,
  Udio,
  Unstructured,
  Upstage,
  V0,
  VectorizerAI,
  Vercel,
  VertexAI,
  Vidu,
  Viggle,
  Vllm,
  Volcengine,
  Voyage,
  Wenxin,
  Windsurf,
  WorkersAI,
  XAI,
  XiaomiMiMo,
  Xinference,
  Xuanyuan,
  Yandex,
  Yi,
  YouMind,
  Yuanbao,
  ZAI,
  Zapier,
  Zeabur,
  ZenMux,
  ZeroOne,
  Zhipu,
};
